<template>
  <div>
    <div class="card border">
      <div class="card-header p-4">
        <div class="d-flex">
          <h5 class="header-case">
            <div>
              STATUS
              <a href="#" class="fa fa-refresh" @click.prevent="refreshBehemothData"></a>
            </div>
          </h5>
          <div class="ml-auto">
            <a
              href="#"
              role="button"
              id="dropdownMenuScraper"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="dots"
            >
              <img src="/assets/img/1.0/three-dots.png" alt="Options" />
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuScraper">
              <a class="dropdown-item cursor-pointer" @click.prevent="copyAllSources">Copy all sources</a>
              <a class="dropdown-item cursor-pointer" @click.prevent="() => setWatchersStatus(true)"
                >Activate all sources</a
              >
              <a class="dropdown-item cursor-pointer" @click.prevent="() => setWatchersStatus(false)"
                >Deactivate all sources</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row justify-content-center text-center mb-4">
          <div class="col-md-1 col d-flex justify-content-center align-items-center">
            <strong>Active</strong>
          </div>
          <div class="col-md-2 col">
            <strong>Channel</strong>
          </div>
          <div class="col-md-2 col">
            <strong>Last Ran</strong>
          </div>
          <div class="col-md-3 col">
            <strong>Source Name</strong>
          </div>
          <div class="col-md-1 col d-flex justify-content-center align-items-center">
            <strong>CW ID</strong>
          </div>
          <div class="col-md-2 col d-flex justify-content-center align-items-center">
            <strong>Options</strong>
          </div>
        </div>
        <div v-for="watcher in behemothStats" :key="watcher.id">
          <div class="row justify-content-center text-center mb-3">
            <div class="col-md-1 col d-flex justify-content-center align-items-center">
              <i class="fa fa-check" v-if="watcher.active === 1" style="color: green"></i>
              <i class="fa fa-times" v-else-if="watcher.active === 0" style="color: red"></i>
            </div>
            <div class="col-md-2 col align-self-start">
              <a class="blue-text" target="_blank" :href="watcher.source.url">
                {{ labelizeGeneral(watcher.provider) }}
              </a>
            </div>
            <div class="col-md-2 col">
              {{ formatDate(watcher.lastRunAt) }}
            </div>
            <div class="col-md-3 col">
              {{ watcher.source.providerName }}
            </div>
            <div class="col-md-1 col d-flex justify-content-center align-items-center">
              <a href="#" @click.prevent="copyWatcher(watcher.id)">{{ watcher.id }}</a>
              <input
                type="text"
                style="position: absolute; z-index: -1; opacity: 0"
                :id="'watcher_' + watcher.id"
                class="hidden"
                :value="'npm run scrape-channel -- --id=' + watcher.id + ' -f'"
              />
            </div>
            <div class="col-md-2 col d-flex justify-content-center align-items-center">
              <a
                href="#"
                role="button"
                id="dropdownMenuSource"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="dots"
              >
                <img src="/assets/img/1.0/three-dots.png" alt="Options" />
              </a>
              <div class="dropdown-menu cursor-pointer" aria-labelledby="dropdownMenuSource">
                <a class="dropdown-item cursor-pointer" v-if="watcher.active === 0" @click="activateWatcher(watcher)"
                  >Activate</a
                >
                <a
                  class="dropdown-item cursor-pointer"
                  v-else-if="watcher.active === 1"
                  @click="deactivateWatcher(watcher)"
                  >Deactivate</a
                >
                <a class="dropdown-item cursor-pointer" @click="deleteReviews(watcher)">Delete All Reviews</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card border">
      <div class="card-header">
        <h5 class="header-case">SCRAPER MANAGEMENT</h5>
      </div>
      <div class="card-header">
        <div class="row">
          <div class="col-md-6">
            <div class="row align-items-center justify-content-center mb-3">
              <div class="col-md-12 ml-3">
                <h5 class="header-case">Re-Run Channels</h5>
                <div v-for="watcher in behemothStats">
                  <div class="col-md-6 d-flex align-items-center">
                    <input
                      type="checkbox"
                      :value="watcher.provider"
                      :id="'channel_rerun' + watcher.provider + watcher.id"
                      v-model="selectedReRunChannels"
                      class="mr-2"
                    />
                    <label :for="'channel_rerun' + watcher.provider + watcher.id" class="w-100 cursor-pointer">{{
                      sourceLabelFromSlug(watcher.provider)
                    }}</label>
                  </div>
                </div>
                <button @click="reRunChannels" class="btn btn-primary mt-3">Re-run channels</button>
              </div>
              <div class="col-md-12 ml-3 mt-3" v-if="false">
                <h5 class="header-case">Active Channels</h5>
                <div v-for="watcher in behemothStats">
                  <div class="col-md-6 d-flex align-items-center">
                    <input
                      type="checkbox"
                      :value="watcher.provider"
                      :id="'channel_activate' + watcher.provider + watcher.id"
                      v-model="selectedActivateChannels"
                      class="mr-2"
                    />
                    <label :for="'channel_activate' + watcher.provider + watcher.id" class="w-100 cursor-pointer">{{
                      sourceLabelFromSlug(watcher.provider)
                    }}</label>
                  </div>
                </div>
                <button @click="activateChannels" class="btn btn-primary mt-3">Update</button>
              </div>
              <div class="col-md-12 ml-3 mt-3">
                <h5 class="header-case">Migrate Reviews</h5>
                <button @click="migrateReviews" class="btn btn-primary mt-3">Migrate Reviews</button>
                <button @click="migrateAllReviews" class="btn btn-danger mt-3 mx-3">Migrate All Reviews</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdministrationMixin from '../AdministrationMixin';

export default {
  props: {
    team: Object,
    teamMetrics: Object,
    partner: {
      type: Object,
      default: null,
    },
  },
  mixins: [AdministrationMixin],
  data() {
    return {
      behemothStats: [],
      selectedReRunChannels: [],
      selectedActivateChannels: [],
    };
  },
  mounted() {
    this.getBehemothData();
  },
  watch: {
    behemothStats: {
      immediate: true,
      handler: function (newVal) {},
    },
  },
  methods: {
    async deleteReviews(watcher) {
      swal({
        title: 'Are you sure?',
        text: 'This will delete all reviews for this channel',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete them!',
        dangerMode: true,
        clickOutside: true,
      }, async(isConfirm) => {
        if (!isConfirm) {
          return;
        }
        const url = `/api/admin/teams/${this.team.id}/delete-reviews`;
        const postData = {
          provider: [watcher.provider],
        };
        try {
          await axios.post(url, postData);
          swal('Good job!', 'Reviews are being deleted', 'success');
        } catch (e) {
          swal('Error', `Could not delete reviews \n${e}`, 'error');
        }
      });
    },
    async activateWatcher(watcher) {
      try {
        const postData = {
          watcherId: this.team.behemoth_watcher_id,
          provider: [watcher.provider],
          data: {
            [watcher.provider]: {
              active: 1,
            },
          },
        };
        await axios.post(this.behemothUrl, postData);

        watcher.active = 1;
      } catch (err) {
        swal('Error', err, 'error');
      }
    },
    async deactivateWatcher(watcher) {
      try {
        const postData = {
          watcherId: this.team.behemoth_watcher_id,
          provider: [watcher.provider],
          data: {
            [watcher.provider]: {
              active: 0,
            },
          },
        };

        await axios.post(this.behemothUrl, postData);

        watcher.active = 0;
      } catch (err) {
        swal('Error', err, 'error');
      }
    },
    async setWatchersStatus(active = true) {
      try {
        const postData = {
          watcherId: this.team.behemoth_watcher_id,
          provider: this.behemothStats.reduce((acc, val) => {
            acc.push(val.provider);
            return acc;
          }, []),
          data: this.behemothStats.reduce((acc, val) => {
            acc[val.provider] = {
              active: Number(active),
            };
            return acc;
          }, {}),
        };
        await axios.post(this.behemothUrl, postData);
        this.behemothStats = this.behemothStats.map((val) => {
          val.active = Number(active);
          return val;
        });

        this.$notify({
          group: 'admin',
          title: 'Success!',
          text: `All channels have been ${active ? 'activated' : 'deactivated'}`,
          position: 'top right',
          duration: 2000,
        });
      } catch (err) {
        swal('Error', err, 'error');
      }
    },
    copyWatcher(watcherId) {
      const text = document.getElementById('watcher_' + watcherId).value;
      navigator.clipboard.writeText(text);
      this.$notify({
        group: 'admin',
        title: 'Success!',
        text: 'The channel has been copied to your clipboard.',
        position: 'top right',
        duration: 2000,
      });
    },
    copyAllSources() {
      const elements = document.querySelectorAll('[id^="watcher_"]');

      let watchers = [];

      elements.forEach((elem) => {
        watchers.push(elem.value);
      });

      const text = watchers.join('&&\n');
      navigator.clipboard.writeText(text);

      this.$notify({
        group: 'admin',
        title: 'Success!',
        text: 'The channels have been copied to your clipboard.',
        position: 'top right',
        duration: 2000,
      });
    },
    async getBehemothData() {
      try {
        this.behemothStats = (await axios.get(this.behemothUrl)).data;
        return true;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
    async refreshBehemothData(event) {
      $(event.target).addClass('fa-spin');
      await this.getBehemothData();
      $(event.target).removeClass('fa-spin');
    },
    reRunChannels() {
      const that = this;

      let postData = {
        watcherId: this.team.behemoth_watcher_id,
        provider: [],
        data: {},
      };

      this.selectedReRunChannels.map(function (val) {
        postData.provider.push(val);
        postData.data[val] = {
          lastRunAt: null,
          active: 1,
        };
      });

      axios
        .post(this.behemothUrl, postData)
        .then(function () {
          swal('OK', 'Selected channels set to re-run', 'success');
          that.getBehemothData();
        })
        .catch(function (err) {
          swal('Error', err, 'error');
        });
    },
    async activateChannels() {
      const that = this;

      let postData = {
        watcherId: this.team.behemoth_watcher_id,
        provider: [],
        data: {},
      };

      this.selectedActivateChannels.map(function (val, idx) {
        let provider = that.behemothStats[idx].provider;
        postData.provider.push(provider);
        postData.data[provider] = { active: val };
      });

      await axios.post(this.behemothUrl, postData);

      this.getBehemothData();
    },
    migrateReviews() {
      axios
        .get(this.behemothMigrateUrl)
        .then(function () {
          swal('OK', 'Review migration has been added to queue', 'success');
        })
        .catch(function (err) {
          swal('Error', err, 'error');
        });
    },
    migrateAllReviews() {
      const that = this;
      swal(
        {
          showCancelButton: true,
          confirmButtonClass: 'btn-danger',
          confirmButtonText: 'Migrate',
          type: 'warning',
          text: `This will re-import all reviews of ${this.team.name}`,
          title: 'Confirm',
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        function (isConfirm) {
          if (isConfirm) {
            axios
              .get(that.behemothMigrateAllUrl)
              .then(function () {
                swal('OK', 'Review migration has been added to queue', 'success');
              })
              .catch(function (err) {
                swal('Error', err, 'error');
              });
          }
        },
      );
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY, h:mma');
      }

      return 'Never';
    },
  },
};
</script>

<style scoped>
.form-wrapper {
  max-width: 400px;
  margin: 0 auto;
}
</style>
